<template>
  <div>
    <b-col
      cols="12"
      v-b-toggle.collapse-extra-options
      v-if="taskTypes !== 'Events'"
      class="d-flex mt-3 cursor-pointer"
      @click="toggleAdvanceSettings"
    >
      <span>More Details</span>
      <span class="material-icons" :class="displayAdvanceSettings ? 'showLess' : 'showMore'"
        >expand_more</span
      >
    </b-col>
    <b-collapse id="collapse-extra-options" class="my-2" :visible="taskTypes === 'Events'">
      <!-- Repeat -->
      <b-col class="mt-3 col-12">
        <label class="font-weight-600 font-size-16 my-2 small-icon">
          <span class="material-icons align-middle">replay</span>
          <span>Repeat</span>
        </label>
        <select v-model="repeatValue" class="text-capitalize atm-input w-100">
          <option v-for="option in repeatOptions" :value="option[0]">
            {{ option[1] }}
          </option>
        </select>
      </b-col>
      <div v-if="repeatValue !== '1'" class="d-flex flex-column mt-3 pl-3">
        <label class="text-uppercase text-dark m-0 small-icon">
          Finish repeat
        </label>
        <input v-model="repeatDateValue" type="date" class="atm-input-time min-content" required />
      </div>
      <b-col cols sm="12" md="12" class="my-2">
        <label class="font-weight-600 font-size-16 my-2 small-icon">
          <span class="material-icons align-middle">notifications</span>
          <span>Notification</span>
        </label>
        <select
          v-model="notificationTypeValue"
          :options="typesNotifications"
          class="atm-input text-capitalize w-100 "
        >
          <option v-for="notificationType in typesNotifications" :value="notificationType[0]">
            {{ notificationType[1] }}
          </option>
        </select>
      </b-col>
      <b-col cols="12" class="mt-3" v-if="showNotificationTime">
        <input type="time" v-model="notificationDateValue" class="atm-input-time mb-3" required />
      </b-col>
      <b-col cols="12" class="my-2">
        <input-file
          :file="fileValue"
          :imageMaxSize="imageMaxSize"
          :error="errorValue"
          :fileInput="fileInput"
          @update:fileData="fileValue = $event"
          @update:fileInput="fileInput = $event"
          @update:error="errorValue = $event"
        >
        </input-file>
        <small class="text-muted d-block">
          Maximum image size 2.5 MB
        </small>
      </b-col>
      <b-col cols="12" class="mt-3">
        <textarea
          v-model="descriptionValue"
          id="assignment-description"
          class="atm-input mt-3 w-100 h-100"
          placeholder="Notes"
        ></textarea>
      </b-col>
    </b-collapse>
  </div>
</template>
<script>
import { InputFile } from '@/common/components';

export default {
  components: {
    InputFile,
  },
  props: {
    description: String,
    taskTypes: String,
    repeat: String,
    repeatOptions: [],
    repeat_date: String,
    notification_type: String,
    typesNotifications: [],
    notification_date: String,
    file: {},
    error: {},
  },
  data() {
    const imageMaxSize = 2500000;
    return {
      displayAdvanceSettings: false,
      imageMaxSize,
      fileInput: null,
    };
  },
  computed: {
    repeatValue: {
      get: function() {
        return this.repeat;
      },
      set: function(newValue) {
        this.$emit('update:repeat', newValue);
      },
    },
    descriptionValue: {
      get: function() {
        return this.description;
      },
      set: function(newValue) {
        this.$emit('update:description', newValue);
      },
    },
    repeatDateValue: {
      get: function() {
        return this.repeat_date;
      },
      set: function(newValue) {
        this.$emit('update:repeatDate', newValue);
      },
    },
    notificationTypeValue: {
      get: function() {
        return this.notification_type;
      },
      set: function(newValue) {
        this.$emit('update:notificationType', newValue);
      },
    },
    notificationDateValue: {
      get: function() {
        return this.notification_date;
      },
      set: function(newValue) {
        this.$emit('update:notificationDate', newValue);
      },
    },
    fileValue: {
      get: function() {
        return this.file;
      },
      set: function(newValue) {
        this.$emit('update:file', newValue);
      },
    },
    errorValue: {
      get: function() {
        return this.error;
      },
      set: function(newValue) {
        this.$emit('update:error', newValue);
      },
    },
    showNotificationTime() {
      return this.notificationTypeValue === '8';
    },
  },
  methods: {
    toggleAdvanceSettings() {
      this.displayAdvanceSettings = !this.displayAdvanceSettings;
    },
    saveFile(event) {
      this.fileValue = event.target.files[0];
    },
  },
};
</script>
<style lang="scss" scoped>
.cursor-pointer {
  cursor: pointer;
}

.showLess {
  transform: rotate(0deg);
  transition: 200ms;
}
.showMore {
  transform: rotate(-90deg);
  transition: 200ms;
}

.min-content {
  width: min-content;
}

.font-weight-600 {
  font-weight: 600;
}

.font-size-16 {
  font-size: 16px !important;
}
</style>
